import React, { useEffect, useState } from "react"
import Calendar from "components/Calendar"
import { connect } from "react-redux"
import { Col, Row, Spinner } from "reactstrap"
import Select from "react-select"
import { getCalendarEvent, getEventsCalendar } from "store/actions"

const ScheduledEventsTab = ({
  businessUnits,
  getEventsCalendar,
  calendars,
  eventsAreLoading,
  calendarEvents,
  getCalendarEvent,
  tabIsActive,
}) => {
  const moment = require("moment-timezone")
  const [selectedBusinesUnit, setSelectedBusinessUnit] = useState({
    value: null,
    label: "Global",
  })

  useEffect(() => {
    if (calendars?.length > 0) {
      getCalendarEvent({
        calendar_ids: calendars?.map(calendar => calendar?.id)?.toString(),
      })
    }
  }, [calendars])

  return (
    <React.Fragment>
      <Row className="my-3">
        <Col xs="auto" className="mt-2">
          <label>Business Unit: </label>
        </Col>
        <Col xs="auto">
          <div style={{ width: "280px" }}>
            <Select
              value={selectedBusinesUnit}
              onChange={v => {
                setSelectedBusinessUnit(v)
                getEventsCalendar({ type: 1, business_unit_id: v?.value })
              }}
              options={[
                { value: null, label: "Global" },
                ...businessUnits?.map(bu => ({
                  value: bu?.id,
                  label: bu?.name,
                })),
              ]}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: provided => ({ ...provided, zIndex: 9999 }),
                menu: provided => ({ ...provided, zIndex: 9999 }),
              }}
            />
          </div>
        </Col>
      </Row>
      {eventsAreLoading && (
        <Row className="d-flex justify-content-center">
          <Col xs="auto">
            <Spinner color="danger" />
          </Col>
        </Row>
      )}
      <Row className="mt-3 d-flex justify-content-center">
        <Col xs="auto" className="mt-2">
          <label>Timezone: </label>
          <span> {moment.tz.guess()}</span>
        </Col>
      </Row>
      <Row>
        <Col>
          <Calendar
            events={
              calendars?.length === 0
                ? []
                : calendarEvents?.map(event => ({
                    title: event?.name,
                    start: new Date(event?.start_date * 1000),
                    end: new Date(event?.end_date * 1000),
                    color: event?.calendar?.color,
                  }))
            }
            timeZone={moment.tz.guess()}
            updateSize={tabIsActive}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  businessUnits: state.businessUnits.businessUnits,
  calendars: state.Events.calendars,
  eventsAreLoading: state.Events.eventsAreLoading,
  calendarEvents: state.Events.calendarEvents,
})

const mapDispatchToProps = dispatch => ({
  getEventsCalendar: values => dispatch(getEventsCalendar(values)),
  getCalendarEvent: values => dispatch(getCalendarEvent(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledEventsTab)
